import { TEXT } from 'locales/translations';
import { Markdown, Paragraph } from 'Common';
import TermsModal from 'components/TermsModal';
import { colors } from 'Theme';
import markdownContentSda from '!!raw-loader!static/health_requirements.md';
import markdownContentResilience from '!!raw-loader!static/resilience_health_requirements.md';

const markdownContent = {
  sda: markdownContentSda,
  resilienz: markdownContentResilience
};

export const HealthRequirementsHint = ({ courseType = 'sda', paragraphClassName = 'extra-small' }) => (
  <Paragraph className={paragraphClassName}>
    {TEXT.formsGeneral.acceptText}
    <TermsModal
      buttonColor="link"
      modalHeaderText="Gesundheitsvoraussetzungen"
      buttonText="Gesundheitsvoraussetzungen"
      renderAs="link"
      color={colors.green.c500}
    >
      <Markdown className="popup" containerId="modal-body" scrollOffset={0}>
        {markdownContent[courseType]}
      </Markdown>
      ;
    </TermsModal>
    {TEXT.formsGeneral.confirmHealthTermsText}
  </Paragraph>
);
